import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

export const API_URL = process.env.REACT_APP_API_URL;

export const getDataAPI = async (url, config) => {
  const session = await fetchAuthSession();
  const token = session.tokens.accessToken;

  return await axios.get(`${API_URL}${url}`, {
    ...config,
    headers: { Authorization: token, ...config?.headers }
  });
};

export const postDataAPI = async (url, body, config) => {
  const session = await fetchAuthSession();
  const token = session.tokens.accessToken;

  const extraHeaders = config?.headers ?? {};
  if (extraHeaders) {
    delete config?.headers;
  }

  return await axios.post(`${API_URL}${url}`, body, {
    ...config,
    headers: { Authorization: token, ...extraHeaders }
  });
};

export const putDataAPI = async (url, post) => {
  const session = await fetchAuthSession();
  const token = session.tokens.accessToken;
  return await axios.put(`${API_URL}${url}`, post, {
    headers: { Authorization: token }
  });
};

export const patchDataAPI = async (url, body, config) => {
  const session = await fetchAuthSession();
  const token = session.tokens.accessToken;
  const extraHeaders = config?.headers ?? {};
  if (extraHeaders) {
    delete config?.headers;
  }
  return await axios.patch(`${API_URL}${url}`, body, {
    headers: { Authorization: token, ...extraHeaders }
  });
};

export const deleteDataAPI = async (url) => {
  const session = await fetchAuthSession();
  const token = session.tokens.accessToken;
  return await axios.delete(`${API_URL}${url}`, {
    headers: { Authorization: token }
  });
};
